/** Kept apart from content.ts so importers of the hash (the offline engine) do not pull zod into the web bundle. */
import { hashCanonical, type Json } from "../canonical/jcs.js";
import type { MbrContent } from "./content.js";

/** sha256(RFC 8785 canonical form) — the version identity that signatures and snapshots bind to (§5.5). */
export function mbrContentHash(content: MbrContent): Promise<string> {
  // JSON round-trip drops `undefined` optionals so the hash is the same whatever path produced the object
  return hashCanonical(JSON.parse(JSON.stringify(content)) as Json);
}
